<template>
  <!-- Card shell used by every dashboard panel: header (optional icon) + actions + body. -->
  <div class="dashboard-card">
    <div class="card-head" :class="{ 'panel-head': icon }">
      <div v-if="icon" class="title-wrap">
        <span class="head-icon" :class="iconTone"><vue-feather :type="icon"></vue-feather></span>
        <div>
          <h4>{{ title }}</h4>
          <p>{{ subtitle }}</p>
        </div>
      </div>
      <div v-else>
        <h4>{{ title }}</h4>
        <p>{{ subtitle }}</p>
      </div>
      <slot name="actions"></slot>
    </div>
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: "DashboardPanel",
  props: {
    title: { type: String, required: true },
    subtitle: { type: String, default: "" },
    icon: { type: String, default: "" },
    // Extra head-icon colour class, e.g. "warn" or "danger".
    iconTone: { type: String, default: "" },
  },
};
</script>
